<template>
  <div>
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex">
          <tabs :data="costTabs" v-model="currentTab"></tabs>
        </div>
      </div>
    </section>
    <section class="grid-flex column">
      <div v-if="currentTab === 'saidas'" class="box w100">
        <div class="box-title flex between middle">
          <h2 class="tooltip">
            Saidas
            <span class="tooltiptext">
              Adicione todas suas saidas. Custo de softwares, funcionários...
            </span>
          </h2>
          <div class="flex end">
            <div class="button primary" @click="showModalCreateOrUpdate = true">Adicionar</div>
          </div>
        </div>
        <div class="box-content">
          <div class="">
            <ul>
              <li v-for="(v, index) in saidas" :key="index">
                <div class="flex middle">
                  <div class="flex-1">{{ v.name }}</div>
                  <div class="flex-1">{{ v.value | money }}</div>
                  <div class="flex-1">{{ v.frequency }}</div>
                  <div class="flex-1">
                    <div class="flex end actions">
                      <div
                        class="button secondary"
                        @click="selectAdditionalValueToEdit(v)"
                      >
                        EDITAR
                      </div>
                      <div
                        class="button secondary"
                        @click="
                          selectedAdditionalValue = v.id;
                          showModalDelete = true;
                        "
                      >
                        REMOVER
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div v-if="isEmptySaida" class="txt-center">
            <p>Não encontramos saidas cadastradas</p>
          </div>

          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>

      <div v-if="currentTab === 'entradas'" class="box w100" style="margin-left: 0px">
        <div class="box-title flex between middle">
          <h2 class="tooltip">
            Entradas
            <span class="tooltiptext">
              Vendeu por uma plataforma que não temos acesso? Adicione como uma entrada manual aqui.
            </span>
          </h2>
          <div class="flex end">
            <div class="button primary" @click="showModalCreateOrUpdate = true">Adicionar</div>
          </div>
        </div>
        <div class="box-content">
          <div>
            <ul>
              <li v-for="(v, index) in entradas" :key="index">
                <div class="flex middle">
                  <div class="flex-1">{{ v.name }}</div>
                  <div class="flex-1">{{ v.value | money }}</div>
                  <div class="flex-1">{{ v.frequency }}</div>
                  <div class="flex-1">
                    <div class="flex end actions">
                      <div
                        class="button secondary"
                        @click="selectAdditionalValueToEdit(v)"
                      >
                        EDITAR
                      </div>
                      <div
                        class="button secondary"
                        @click="
                          selectedAdditionalValue = v.id;
                          showModalDelete = true;
                        "
                      >
                        REMOVER
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div v-if="isEmptyEntradas" class="txt-center">
            <p>Não encontramos entradas cadastradas</p>
          </div>

          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>


      <!-- modal confirm delete -->
      <modal-confirm
        :show="showModalDelete"
        description="Você tem certeza que deseja deletar esse usuário?"
        @cancel="
          showModalDelete = false;
          selectedAdditionalValue = null;
        "
        @accept="deleteAdditionalvalue(selectedAdditionalValue)"
      ></modal-confirm>

      <modal
        :title="modalTitle"
        :show="showModalCreateOrUpdate"
        @close="cleanModal()"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form autocomplete="off" class="w100">
              <div class="flex-1 w100">
                <label>Nome</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newAddition.name"
                  autocomplete="off"
                />
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>Valor:</label>
                <money v-model="newAddition.value" v-bind="money"></money>
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>Frequência:</label>
                <select class="input" v-model="newAddition.frequency">
                  <option value="">Seleciona</option>
                  <option v-for="(f, index) in listFrequency" :key="index" :value="f" :selected="f === newAddition.frequency">
                    {{ f }}
                  </option>
                </select>
              </div>

            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="saveOrUpdateAdditionalValue()">SALVAR</div>
            </div>
          </div>
        </div>
      </modal>
    </section>
  </div>
</template>

<script>

// TODO: Adicionar modal para justificar como os dados vão ser aplicados.

import { mapState } from "vuex";

import { Money } from 'v-money'

import {
  getAdditionalvalue,
  createAdditionalvalue,
  updateAdditionalValue,
  deleteAdditionalvalue
} from "@/services/additionalvalue";

import Tabs from "@/components/tabs/Tabs";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

export default {
  name: "additional-value",
  components: {
    Tabs,
    Modal,
    ModalConfirm,
    Money
  },
  data() {
    return {
      loading: false,
      currentTab: "saidas",
      costTabs: [
        {
          name: "saidas",
          title: "Saidas",
        },
        {
          name: "entradas",
          title: "Entradas",
        },
      ],
      saidas: [],
      entradas: [],
      listFrequency: [
        'UNICO',
        'MENSAL',
        // 'TRIMESTRAL',
        // 'SEMESTRAL',
        // 'ANUAL',
      ],
      selectedAdditionalValue: null,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      newAddition: {
        name: '',
        value: 0,
        frequency: 'MENSAL'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  mounted() {
    this.getAdditionalvalue('SAIDA')
    this.getAdditionalvalue('ENTRADA')
  },
  computed: {
    ...mapState({
      user: state => state.user,
      account: state => state.account
    }),
    modalTitle() {
      return this.selectedAdditionalValue ? "Editar Valor Adicional" : "Adicionar Valor Adicional";
    },
    isEmptySaida() {
      return !this.loading && this.saidas && this.saidas.length === 0
    },
    isEmptyEntradas() {
      return !this.loading && this.entradas && this.entradas.length === 0
    }
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    selectAdditionalValueToEdit(additionalvalue) {
      this.selectedAdditionalValue = additionalvalue.id;
      this.newAddition = this.$ObjectCopy(additionalvalue);
      this.showModalCreateOrUpdate = true;
    },
    cleanModal() {
      this.selectedAdditionalValue = null;
      this.showModalCreateOrUpdate = false;
      this.newAddition = {
        name: '',
        value: 0,
        frequency: 'MENSAL'
      };
    },
    saveOrUpdateAdditionalValue() {
      if (this.selectedAdditionalValue) {
        this.updateAdditionalvalue();
      } else {
        this.createAdditionalvalue();
      }

      this.cleanModal();
    },
    getAdditionalvalue(type) {
      this.loading = true
      getAdditionalvalue({type: type })
        .then((result) => {
          if (type == 'ENTRADA') {
            this.entradas = result
          } else {
            this.saidas = result
          }
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Falhou ao buscar dados'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    createAdditionalvalue() {
      let params = {
        ...this.newAddition,
        value_type: (this.currentTab === 'entradas'? 'ENTRADA' : 'SAIDA')
      }

      createAdditionalvalue(params)
        .then((result) => {
          if (this.currentTab === 'entradas') {
            this.entradas.push(result)
          } else {
            this.saidas.push(result)
          }

          this.$toast.success({
            title:'Sucesso',
            message:'Valor adicional criado'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Error ao criar valor adicional'
          })
        })
    },
    deleteAdditionalvalue(additionalvalue) {
      deleteAdditionalvalue(additionalvalue)
      .then(() => {
        this.entradas = this.entradas.filter(f => f.id != additionalvalue)
        this.saidas = this.saidas.filter(f => f.id != additionalvalue)
      })
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Falha ao tentar remover valor adicional'
        })
      })
      .finally(() => {
        this.selectedAdditionalValue = null
        this.showModalDelete = false
      })
    },
    updateAdditionalvalue() {
      let params = {
        ...this.newAddition,
        value_type: (this.currentTab === 'entradas'? 'ENTRADA' : 'SAIDA')
      }

      updateAdditionalValue(this.selectedAdditionalValue, params)
        .then((result) => {
          let index = this.entradas.findIndex((e) => e.id == result.id)
          if (index > -1) {
            this.entradas[index] = result
          }

          index = this.saidas.findIndex((e) => e.id == result.id)
          if (index > -1) {
            this.saidas[index] = result
          }

        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Erro ao editar valor adicional'
          })
        })

    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  .box-content {
    max-height: 750px;
    overflow-y: auto;
  }
}

ul {
  li {
    list-style-type: none;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #c2c2c258;
  }
}

.actions {
  > div {
    margin-left: 4px;
  }
}

</style>
